import React from "react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { ShopHero } from "@/components/shop/ShopHero";
import { ShopFlagship } from "@/components/shop/ShopFlagship";
import { ShopProducts } from "@/components/shop/ShopProducts";
import SEOHead from "@/components/SEOHead";

const Shop = () => {
  return (
    <>
      <SEOHead
        title="Shop Faith-Rooted Tools for Burnout Recovery: Ieshia Danielle"
        description="Workbooks, workshops, the Bible Babes Budgeting app, and free guides for the woman who is done surviving and ready to steward what God placed in her hands."
        canonical="https://iamieshiadanielle.com/shop"
        ogImage="https://vibe.filesafe.space/1787853701390843161/assets/a5d05b54-0df1-474c-a727-ad33093a5f8e.png"
        schemaJson={[
          {
            "@type": "WebPage",
            "@id": "https://iamieshiadanielle.com/shop#webpage",
            url: "https://iamieshiadanielle.com/shop",
            name: "Shop Faith-Rooted Tools for Burnout Recovery: Ieshia Danielle",
            isPartOf: { "@id": "https://iamieshiadanielle.com/#website" },
            about: { "@id": "https://iamieshiadanielle.com/#person" },
            inLanguage: "en-US",
          },
          {
            "@type": "BreadcrumbList",
            itemListElement: [
              {
                "@type": "ListItem",
                position: 1,
                name: "Home",
                item: "https://iamieshiadanielle.com",
              },
              {
                "@type": "ListItem",
                position: 2,
                name: "Shop",
                item: "https://iamieshiadanielle.com/shop",
              },
            ],
          },
          {
            "@type": "ItemList",
            "@id": "https://iamieshiadanielle.com/shop#catalog",
            name: "Ieshia Danielle Tools and Resources",
            itemListElement: [
              {
                "@type": "ListItem",
                position: 1,
                item: {
                  "@type": "Product",
                  "@id":
                    "https://iamieshiadanielle.com/programs/becoming-intensive#product",
                  name: "Becoming Intensive",
                  description:
                    "A six-week experience with Scripture-rooted teaching, live coaching, community, and practical accountability across the six areas shaping your life.",
                  url: "https://iamieshiadanielle.com/programs/becoming-intensive",
                  offers: {
                    "@type": "Offer",
                    price: "997",
                    priceCurrency: "USD",
                    availability: "https://schema.org/InStock",
                  },
                },
              },
              {
                "@type": "ListItem",
                position: 2,
                item: {
                  "@type": "Product",
                  "@id":
                    "https://iamieshiadanielle.com/programs/identity-reset#product",
                  name: "Identity Reset",
                  description:
                    "Renew the beliefs and labels quietly shaping your choices.",
                  url: "https://iamieshiadanielle.com/programs/identity-reset",
                  offers: {
                    "@type": "Offer",
                    price: "47",
                    priceCurrency: "USD",
                    availability: "https://schema.org/InStock",
                  },
                },
              },
              {
                "@type": "ListItem",
                position: 3,
                item: {
                  "@type": "Product",
                  "@id":
                    "https://iamieshiadanielle.com/programs/workbook#product",
                  name: "From Burnout to Becoming Workbook",
                  description:
                    "Name your burnout source and write a practical plan forward.",
                  url: "https://iamieshiadanielle.com/programs/workbook",
                  offers: {
                    "@type": "Offer",
                    price: "27",
                    priceCurrency: "USD",
                    availability: "https://schema.org/InStock",
                  },
                },
              },
              {
                "@type": "ListItem",
                position: 4,
                item: {
                  "@type": "Product",
                  name: "Identity Reset + Workbook Bundle",
                  description:
                    "Save when you bundle the Identity Reset workshop with the workbook.",
                  url: "https://store.iamieshiadanielle.com/product-details/product/6a98cd6f86a8dfe2ef9d9ef1/?variant=6a98cd6f86a8dfe2ef9d9ef9",
                  offers: {
                    "@type": "Offer",
                    price: "55",
                    priceCurrency: "USD",
                    availability: "https://schema.org/InStock",
                  },
                },
              },
              {
                "@type": "ListItem",
                position: 5,
                item: {
                  "@type": "Product",
                  name: "When God Says Let Go",
                  description:
                    "A faith-centered guide for releasing what God is asking you to leave.",
                  url: "https://store.iamieshiadanielle.com/product-details/product/when-god-says-let-go-guided-workbook-by-ieshia-danielle",
                  offers: {
                    "@type": "Offer",
                    price: "20",
                    priceCurrency: "USD",
                    availability: "https://schema.org/InStock",
                  },
                },
              },
              {
                "@type": "ListItem",
                position: 6,
                item: {
                  "@type": "Product",
                  name: "Bible Babes Budgeting App",
                  description:
                    "Build financial stewardship into your everyday life.",
                  url: "https://store.iamieshiadanielle.com/product-details/product/bible-babes-budgeting-app",
                  offers: {
                    "@type": "Offer",
                    price: "15",
                    priceCurrency: "USD",
                    availability: "https://schema.org/InStock",
                    priceSpecification: {
                      "@type": "UnitPriceSpecification",
                      price: "15",
                      priceCurrency: "USD",
                      unitCode: "MON",
                    },
                  },
                },
              },
              {
                "@type": "ListItem",
                position: 7,
                item: {
                  "@type": "Product",
                  name: "Biblical Affirmations",
                  description:
                    "Renew your mind with truth you can return to every day.",
                  url: "https://store.iamieshiadanielle.com/product-details/product/free-christian-affirmations-2026-speak-life-daily",
                  offers: {
                    "@type": "Offer",
                    price: "0",
                    priceCurrency: "USD",
                    availability: "https://schema.org/InStock",
                  },
                },
              },
              {
                "@type": "ListItem",
                position: 8,
                item: {
                  "@type": "Product",
                  name: "Don't Marry That Man",
                  description:
                    "A discernment guide for the woman who needs clarity.",
                  url: "https://store.iamieshiadanielle.com/product-details/product/don-t-marry-that-man-free-christian-discernment-guide",
                  offers: {
                    "@type": "Offer",
                    price: "0",
                    priceCurrency: "USD",
                    availability: "https://schema.org/InStock",
                  },
                },
              },
            ],
          },
        ]}
      />
      <div className="min-h-screen bg-[#FAF6F0] text-[#380C1E] flex flex-col font-sans">
        <Header />
        <main className="flex-1">
          <ShopHero />
          <ShopFlagship />
          <ShopProducts />
        </main>
        <Footer />
      </div>
    </>
  );
};

export default Shop;
